<template>
  <div
    class="create-owner-program bg-u-px-md"
    data-testid="create-owner-program"
  >
    <bg-breadcrumb :links="breadcrumbLinks" tag="router-link" />

    <owner-program-form ref="formRef" class="bg-u-mt-md" />

    <bg-modal
      :value="isPromptOpen"
      data-testid="leave-confirmation-modal"
      title="Yakin keluar tanpa menyimpan?"
      description="Program yang sedang Anda buat belum disimpan. Simpan sebagai
      draft sebelum meninggalkan halaman ini?"
      button-main-text="Simpan Draft"
      button-second-text="Lanjut Buat Program"
      :button-main-props="{ loading: isProcessing }"
      :body-scroll="false"
      @input="handlePromptInput"
      @click-main-action="confirmLeave"
      @click-second-action="cancelLeave"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { BgBreadcrumb, BgModal } from 'bangul-vue';

import OwnerProgramForm from '@admin/components/pages/OwnerProgram/OwnerProgramForm/OwnerProgramForm.vue';
import { useUnsavedChangesGuard } from '@/composables/useUnsavedChangesGuard';

export default {
  name: 'CreateOwnerProgram',

  components: {
    BgBreadcrumb,
    BgModal,
    OwnerProgramForm,
  },

  /*
   * Leaving "Buat Program" is a page-level concern: in-component leave guards
   * are only collected from routed components, so the guard lives here and
   * delegates to the form (which owns the unsaved-changes state and save).
   */
  beforeRouteLeave(to, from, next) {
    this.guardLeave(next);
  },

  setup() {
    const formRef = ref(null);

    const breadcrumbLinks = [
      {
        name: 'Program Pemilik',
        url: '/owner-program',
      },
      {
        name: 'Buat Program',
        url: '/owner-program/create',
      },
    ];

    const hasUnsavedChanges = () =>
      !!(formRef.value && formRef.value.hasUnsavedChanges);

    const {
      isPromptOpen,
      isProcessing,
      guardLeave,
      confirmLeave,
      cancelLeave,
      handlePromptInput,
    } = useUnsavedChangesGuard({
      hasUnsavedChanges,
      onConfirm: () => formRef.value.saveAsDraft(),
    });

    return {
      formRef,
      breadcrumbLinks,
      isPromptOpen,
      isProcessing,
      guardLeave,
      confirmLeave,
      cancelLeave,
      handlePromptInput,
    };
  },
};
</script>
